var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomBtn',{attrs:{"icon":"mdi-refresh","text":_vm.$t('update'),"min-width":_vm.minWidth,"block":_vm.block},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }